module.exports = __webpack_public_path__ + "static/media/bg-new-subdomains.91c5ce2b.jpg";